import MobileSecondaryNavStatusAtom from "utilities/atoms/bookview/mobile-secondary-nav-status-atom";
import { useAtom } from "jotai";
import { MobileSecondaryNavStatus } from "models/enumerations/mobile-secondary-nav-status";

export function useMobileSecondaryNavContent() {
    const [mobileSecondaryNavStatus, setMobileSecondaryNavStatus] = useAtom(
        MobileSecondaryNavStatusAtom
    );

    const isRefModalOpen =
        mobileSecondaryNavStatus === MobileSecondaryNavStatus.ReferenceContent;
    const isUserPreferenceModalOpen =
        mobileSecondaryNavStatus ===
        MobileSecondaryNavStatus.UserSettingsContent;
    const isShareSpaceModalOpen =
        mobileSecondaryNavStatus === MobileSecondaryNavStatus.ShareSpaceContent;
    const isSecondaryNavModalOpen =
        mobileSecondaryNavStatus ===
        MobileSecondaryNavStatus.SecondaryNavContent;
    const isBookviewSearchPanelOpen =
        mobileSecondaryNavStatus ===
        MobileSecondaryNavStatus.BookviewSearchPanel;

    const handleClose = () => {
        setMobileSecondaryNavStatus(
            MobileSecondaryNavStatus.SecondaryNavContent
        );
    };

    const toggleModalContents = (
        modalContentStatus: MobileSecondaryNavStatus
    ) => {
        mobileSecondaryNavStatus === modalContentStatus
            ? setMobileSecondaryNavStatus(
                  MobileSecondaryNavStatus.SecondaryNavContent
              )
            : setMobileSecondaryNavStatus(modalContentStatus);
    };

    const toggleReferenceModal = () => {
        toggleModalContents(MobileSecondaryNavStatus.ReferenceContent);
    };

    const toggleUserPreferencesModal = () => {
        toggleModalContents(MobileSecondaryNavStatus.UserSettingsContent);
    };

    const toggleShareSpaceModal = () => {
        toggleModalContents(MobileSecondaryNavStatus.ShareSpaceContent);
    };

    const toggleSecondaryNavModal = () => {
        toggleModalContents(MobileSecondaryNavStatus.SecondaryNavContent);
    };

    const toggleBookviewSearchPanel = () => {
        toggleModalContents(MobileSecondaryNavStatus.BookviewSearchPanel);
    };

    return {
        handleClose,
        toggleReferenceModal,
        toggleUserPreferencesModal,
        toggleShareSpaceModal,
        toggleSecondaryNavModal,
        toggleBookviewSearchPanel,
        isRefModalOpen,
        isUserPreferenceModalOpen,
        isShareSpaceModalOpen,
        isSecondaryNavModalOpen,
        isBookviewSearchPanelOpen,
    };
}
